import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserEnrollSessionService } from 'src/app/@services/user-enroll-session.service';
import { EventConfigStateService } from 'src/app/@store/event-config-state.service';
import { ExternalRegistrationStateService } from 'src/app/@store/external-registration-state.service';

// TODO: @later Upgrade checklist item: Update usages of Resolve interface to include RedirectCommand in its return type.
export const determineSessionRegistrationId: ResolveFn<boolean> = (
  route,
  _state
) => {
  const eventConfigState = inject(EventConfigStateService);
  const externalRegistrationState = inject(ExternalRegistrationStateService);
  const userSessionService = inject(UserEnrollSessionService);
  const router = inject(Router);

  const registrationId = route.paramMap.get('registrationId') ?? '';
  const sessionId = route.paramMap.get('sessionId') ?? '';

  externalRegistrationState.setRegistrationId(registrationId);

  return userSessionService
    .ensureValidEnrolledUserSession({
      eventNameIdentifier: eventConfigState.$eventIdentifier(),
      userIdentifier: registrationId,
    })
    .pipe(
      map(
        () =>
          new RedirectCommand(router.createUrlTree(['session', sessionId]), {
            skipLocationChange: true,
          })
      )
    );
};
